import React from "react";
import { MdLockOutline } from "react-icons/md";
import EAButton from "../Buttons/EAButton";
import "./EAFeatureLock.scss";

interface IProps {
  title: string;
  description: string;
  actionLabel?: string;
  onAction?: () => void;
}

const EAFeatureLock: React.FC<IProps> = ({ title, description, actionLabel, onAction }) => {
  return (
    <div className="feature-lock">
      <div className="feature-lock__icon-wrapper">
        <MdLockOutline className="feature-lock__icon" />
      </div>
      <h4 className="feature-lock__title">{title}</h4>
      <p className="feature-lock__description">{description}</p>
      {actionLabel && onAction && (
        <EAButton title={actionLabel} onClick={onAction} variant="filled" color="primary" />
      )}
    </div>
  );
};

export default EAFeatureLock;
